import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "N. OP:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Engenharia:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Quantidade:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Status:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { style: {"width":"7cm"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.ordemProducao.numero), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.ordemProducao.nomeEngenharia || 'Não informado'), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.ordemProducao.quantidade, 4, false)), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.statusTexto), 1)
      ]),
      _createVNode(_component_a_progress, {
        percent: _ctx.ordemProducao.percentualConcluido,
        size: "small"
      }, null, 8, ["percent"])
    ]),
    _: 1
  }))
}